import { useAtomValue } from 'jotai'
import Avatar from '@mui/material/Avatar'
import Typography from '@mui/material/Typography'
import Icon from '@mui/material/Icon'
import Box from "@mui/material/Box"

import { UserRole } from '@/types'
import LoadingBox from '@/components/loading-box'
import ErrorBox from '@/components/error-box'
import { useMunicipalities } from '@/hooks/api/use-municipality'
import { selectedMunicipalityIdAtom } from '@/state'
import { getUserRole } from '@/helpers'

interface MunicipalityPermissionGateProps {
    children: React.ReactNode
    hide?: boolean
}

const MunicipalityPermissionGate: React.FC<MunicipalityPermissionGateProps> = ({
    children,
    hide,
}) => {

    const municipalityId = useAtomValue(selectedMunicipalityIdAtom)

    const { status, data, error } = useMunicipalities()

    if (!municipalityId) {
        return <Box>
            Vyberte prosím konkrétní obec výše.
        </Box>
    }

    if (status === 'pending') {
        return <LoadingBox />
    }

    if (error) {
        return <ErrorBox
            error={error}
            message={'Nepovedlo se načíst obce'}
        />
    }

    const sharesWithCollectionCompany = data.find(municipality => municipality.id === municipalityId)?.is_visible_for_collection_company

    const role = getUserRole()

    if (role === UserRole.collectionCompany && !sharesWithCollectionCompany && hide) return null

    if (role === UserRole.collectionCompany && !sharesWithCollectionCompany) return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            alignItems: 'center',
        }}>
            <Avatar sx={(theme) => ({
                width: theme.spacing(10),
                height: theme.spacing(10),
                backgroundColor: 'grey.300',
                margin: theme.spacing(3),
            })}>
                <Icon sx={{
                    fontSize: '3rem',
                    color: 'white',
                }}>
                    lock
                </Icon>
            </Avatar>
            <Typography
                variant="subtitle2"
                component="div"
                sx={(theme) => ({
                    color: 'grey.400',
                    marginBottom: theme.spacing(2),
                    textAlign: 'center',
                })}
            >
                Tato obec s Vámi nesdílí informace o správě.
            </Typography>
        </Box>
    )

    return <>{children}</>
}

export default MunicipalityPermissionGate
